import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { ETyprOffersShow, viewOfferByOID } from 'src/app/domain/interfaces/type-offers-cross-sell/type-offers-show-enum';

@Component({
  selector: 'app-crosssell5',
  templateUrl: './crosssell5.component.html',
  styleUrls: ['./crosssell5.component.scss']
})
export class Crosssell5Component implements OnInit {
  @Input() OfferId!: string;
  @Input() UserInfo!: string;
  public showPersonalLoanOffers: boolean = false
  public showCreditCardsOffers: boolean = false
  public showCashDealsOffers: boolean = false
  public activeOffers: string = ""
  public containerSection!: HTMLElement | null;
  public viewButtonByOffers;

  constructor(private renderer: Renderer2) {
    this.viewButtonByOffers = viewOfferByOID;
  }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    this.containerSection = document.getElementById("container-section");
  }

  handlerSelecteOffers(event: any) {
    if (!this.containerSection?.classList.contains("container-section-active-offer")) {
      this.containerSection?.classList.replace("container-section", "container-section-active-offer");
    }
    this.activeOffers = event.target.dataset.action;
    switch (event.target.dataset.action) {
      case ETyprOffersShow.personalLoan:
        this.showPersonalLoanOffers = true;
        this.showCashDealsOffers = false;
        this.showCreditCardsOffers = false;
        break;
      case ETyprOffersShow.cashDeals:
        this.showCashDealsOffers = true;
        this.showPersonalLoanOffers = false;
        this.showCreditCardsOffers = false;
        break;
      case ETyprOffersShow.creditCart:
        this.showCreditCardsOffers = true;
        this.showCashDealsOffers = false;
        this.showPersonalLoanOffers = false;
        break;
    }
    setTimeout(() => {
      const element = document.querySelectorAll(`#${event.target.dataset.action}`);
      element.forEach(element => this.renderer.addClass(element, "animation"))
    }, 0.1)

  }

  handlerBack() {
    if (this.containerSection?.classList.contains("container-section-active-offer")) {
      this.containerSection?.classList.replace("container-section-active-offer", "container-section");
    }
    this.activeOffers = "";
    this.showCreditCardsOffers = false;
    this.showCashDealsOffers = false;
    this.showPersonalLoanOffers = false;
    setTimeout(() => {
      const offersButton = document.querySelectorAll("#offer-button");
      offersButton.forEach(element => this.renderer.addClass(element, "animation"))
    }, 0.1)
  }
}
